// Project a drag onto the nearest position that keeps a member card in view.
// Individual cards matter: the overall tree bounds can contain large empty gaps.
export function constrainTreePan(view, viewport, cards) {
  if (!cards.length || viewport.width <= 0 || viewport.height <= 0) return view;
  const left = Math.min(24, viewport.width / 4);
  const right = viewport.width - left;
  const top = Math.min(72, viewport.height / 4);
  const bottom = viewport.height - Math.min(80, viewport.height / 4);
  let nearest = view;
  let distance = Infinity;
  for (const card of cards) {
    const x1 = left - card.left * view.scale;
    const x2 = right - card.right * view.scale;
    const y1 = top - card.top * view.scale;
    const y2 = bottom - card.bottom * view.scale;
    // When zoomed beyond the viewport, keep the largest possible area visible.
    const positionX = Math.max(Math.min(x1, x2), Math.min(Math.max(x1, x2), view.positionX));
    const positionY = Math.max(Math.min(y1, y2), Math.min(Math.max(y1, y2), view.positionY));
    const delta = (positionX - view.positionX) ** 2 + (positionY - view.positionY) ** 2;
    if (delta === 0) return view;
    if (delta < distance) {
      distance = delta;
      nearest = { ...view, positionX, positionY };
    }
  }
  return nearest;
}

export function hiddenDirections(view, viewport, bounds) {
  const { scale, positionX: x, positionY: y } = view;
  return {
    left: x + bounds.left * scale < 23,
    right: x + bounds.right * scale > viewport.width - 23,
    top: y + bounds.top * scale < 71,
    bottom: y + bounds.bottom * scale > viewport.height - 79,
  };
}

export function fitTree(viewport, bounds, maxScale = 3) {
  const scale = Math.max(0.01, Math.min(maxScale, (viewport.width - 48) / (bounds.right - bounds.left),
    (viewport.height - 152) / (bounds.bottom - bounds.top)));
  return {
    scale,
    x: viewport.width / 2 - (bounds.left + bounds.right) * scale / 2,
    y: 72 + (viewport.height - 152) / 2 - (bounds.top + bounds.bottom) * scale / 2,
  };
}
